import React from 'react'
import LayoutPage from '../../hoc/LayoutPage/LayoutPage'
import { shortName } from '../../constants'
import collection1 from '../../assets/26/collectionTezis/УОМШ-26 - 1_260927_144021.pdf'
import collection2 from '../../assets/26/collectionTezis/УОМШ-26 - 2_260927_143951.pdf'

const Collection = () => {
    return (
        <LayoutPage headling={`Сборник тезисов ${shortName}`}>

            <ul>
                <li><a href={collection1}>Тезисы {shortName}. Том 1</a></li>
                <li><a href={collection2}>Тезисы {shortName}. Том 2</a></li>
            </ul>
        </LayoutPage>
    )
}

export default Collection
